import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface Sidebar {
  open: boolean
}

const initialState: Sidebar = { open: true }

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarStatus: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload
    },
  },
})

export const { setSidebarStatus } = sidebarSlice.actions
export default sidebarSlice.reducer
